import { createSelector } from "@ngrx/store";
import { AppState } from "../../app.state";
import { selectCatalogosState } from "../catalogos/selector";
import {
  selectTemasUsuario,
  selectTemasUsuarioLectura,
} from "../usuario/selector";

export const selectBusquedaState = (state: AppState) => state.busqueda;
export const selectBusquedaEntradas = createSelector(
  selectBusquedaState,
  (state) => state.entradas
);

export const selectBusqueda = createSelector(
  selectBusquedaState,
  (state) => state
);

export const selectCatBusquedaAvanzada = createSelector(
  selectTemasUsuarioLectura, // Selector para el estado de usuarios
  selectCatalogosState, // Selector para el estado de catálogos
  selectTemasUsuario,
  (temasUsuario, catalogoTemas, temas) => {
    const catTemas = catalogoTemas.catTema.filter((temaCatalogo) =>
      temasUsuario.some((temaUsuario) => temaCatalogo.id === temaUsuario.id)
    );
    const catTipos = catalogoTemas.catTipo.filter((cat) => cat.activo);
    const catmodoEntrada = catalogoTemas.catModoEntrada.filter((cat) => cat.activo);
    const catPrioridad = catalogoTemas.catPrioridad.filter((cat) => cat.activo);
    const catRemitente = catalogoTemas.catRemitente.filter((cat) => cat.activo);
    const catEmpresas = catalogoTemas.catEmpresa.filter((cat) => cat.activo);
    const catEstatus = catalogoTemas?.catEstatus?.filter((cat) => cat.activo);
    const idsTemas = Object.keys(temas);
    const combos = {
      idsTemas,
      catTemas,
      catTipos,
      catmodoEntrada,
      catPrioridad,
      catRemitente,
      catEmpresas,
      catEstatus,
    };
    return combos;
  }
);
